<template>
  <svg
    fill="none"
    height="1507"
    viewBox="0 0 550 1507"
    width="550"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      fill="#F4F6F8"
      height="80"
      rx="8"
      width="80"
      x="-34"
      y="671"
    />
    <rect
      fill="#F6F8FA"
      height="80"
      rx="8"
      width="80"
      x="-34"
      y="755"
    />
    <rect
      fill="#F2F5F9"
      height="80"
      rx="8"
      width="80"
      x="-34"
      y="839"
    />
    <rect
      fill="#EBEDF5"
      height="80"
      rx="8"
      width="80"
      x="-34"
      y="923"
    />
    <rect
      fill="#F4F6F8"
      height="80"
      rx="8"
      width="80"
      x="-34"
      y="1007"
    />
    <rect
      fill="#F2F5F9"
      height="80"
      rx="8"
      width="80"
      x="-34"
      y="1175"
    />
    <rect
      fill="#F2F5F9"
      height="80"
      rx="8"
      width="80"
      x="-34"
      y="1259"
    />
    <rect
      fill="#F6F8FA"
      height="80"
      rx="8"
      width="80"
      x="-34"
      y="1343"
    />
    <rect
      fill="#F8FAFB"
      height="80"
      rx="8"
      width="80"
      x="50"
      y="671"
    />
    <rect
      fill="#F6F8FA"
      height="80"
      rx="8"
      width="80"
      x="50"
      y="755"
    />
    <rect
      fill="#F2F5F9"
      height="80"
      rx="8"
      width="80"
      x="50"
      y="923"
    />
    <rect
      fill="#F2F5F9"
      height="80"
      rx="8"
      width="80"
      x="50"
      y="1007"
    />
    <rect
      fill="#F6F8F9"
      height="80"
      rx="8"
      width="80"
      x="50"
      y="1259"
    />
    <rect
      fill="#F8FAFB"
      height="80"
      rx="8"
      width="80"
      x="134"
      y="671"
    />
    <rect
      fill="#F6F8FA"
      height="80"
      rx="8"
      width="80"
      x="134"
      y="755"
    />
    <rect
      fill="#F6F8FA"
      height="80"
      rx="8"
      width="80"
      x="-34"
      y="587"
    />
    <rect
      fill="#F6F8FA"
      height="80"
      rx="8"
      width="80"
      x="50"
      y="839"
    />
    <rect
      fill="#F6F8FA"
      height="80"
      rx="8"
      width="80"
      x="134"
      y="839"
    />
    <rect
      fill="#F2F5F9"
      height="80"
      rx="8"
      width="80"
      x="134"
      y="923"
    />
    <rect
      fill="#F6F8FA"
      height="80"
      rx="8"
      width="80"
      x="134"
      y="1259"
    />
    <rect
      fill="#F6F8FA"
      height="80"
      rx="8"
      width="80"
      x="134"
      y="1343"
    />
    <rect
      fill="#F8FAFB"
      height="80"
      rx="8"
      width="80"
      x="134"
      y="1427"
    />
    <rect
      fill="#F6F8FA"
      height="80"
      rx="8"
      width="80"
      x="218"
      y="671"
    />
    <rect
      fill="#F8FAFB"
      height="80"
      rx="8"
      width="80"
      x="218"
      y="755"
    />
    <rect
      fill="#F6F8FA"
      height="80"
      rx="8"
      width="80"
      x="218"
      y="1007"
    />
    <rect
      fill="#F8FAFB"
      height="80"
      rx="8"
      width="80"
      x="218"
      y="1343"
    />
    <rect
      fill="#F8FAFB"
      height="80"
      rx="8"
      width="80"
      x="218"
      y="1427"
    />
    <rect
      fill="#F8FAFB"
      height="80"
      rx="8"
      width="80"
      x="302"
      y="671"
    />
    <rect
      fill="#F6F8FA"
      height="80"
      rx="8"
      transform="rotate(180 298 1003)"
      width="80"
      x="298"
      y="1003"
    />
    <rect
      fill="#F6F8FA"
      height="80"
      rx="8"
      width="80"
      x="302"
      y="839"
    />
    <rect
      fill="#F6F8FA"
      height="80"
      rx="8"
      width="80"
      x="52"
      y="1343"
    />
    <rect
      fill="#F6F8FA"
      height="80"
      rx="8"
      width="80"
      x="302"
      y="1007"
    />
    <rect
      fill="#F6F8FA"
      height="80"
      rx="8"
      width="80"
      x="218"
      y="1427"
    />
    <rect
      fill="#F8FAFB"
      height="80"
      rx="8"
      width="80"
      x="302"
      y="1427"
    />
    <rect
      fill="#F8FAFB"
      height="80"
      rx="8"
      transform="matrix(-1 0 0 1 46 840)"
      width="80"
    />
    <rect
      fill="#F9FBFC"
      height="80"
      rx="8"
      transform="matrix(1 0 0 -1 470 836)"
      width="80"
    />
    <rect
      fill="#F8FAFB"
      height="80"
      rx="8"
      transform="matrix(1 0 0 -1 470 416)"
      width="80"
    />
    <rect
      fill="#F8FAFB"
      height="80"
      rx="8"
      transform="matrix(1 0 0 -1 470 332)"
      width="80"
    />
    <rect
      fill="#F8FAFB"
      height="80"
      rx="8"
      transform="matrix(1 0 0 -1 470 248)"
      width="80"
    />
    <rect
      fill="#F9FBFC"
      height="80"
      rx="8"
      transform="matrix(1 0 0 -1 470 164)"
      width="80"
    />
    <rect
      fill="#F9FAFC"
      height="80"
      rx="8"
      transform="matrix(1 0 0 -1 386 836)"
      width="80"
    />
    <rect
      fill="#F8FAFB"
      height="80"
      rx="8"
      transform="matrix(1 0 0 -1 386 752)"
      width="80"
    />
    <rect
      fill="#F8FAFB"
      height="80"
      rx="8"
      transform="matrix(1 0 0 -1 386 668)"
      width="80"
    />
    <rect
      fill="#F8FAFB"
      height="80"
      rx="8"
      transform="matrix(1 0 0 -1 386 248)"
      width="80"
    />
    <rect
      fill="#F8FAFB"
      height="80"
      rx="8"
      transform="matrix(1 0 0 -1 386 164)"
      width="80"
    />
    <rect
      fill="#F9FAFB"
      height="80"
      rx="8"
      transform="matrix(1 0 0 -1 386 80)"
      width="80"
    />
    <rect
      fill="#F8FAFB"
      height="80"
      rx="8"
      transform="matrix(1 0 0 -1 302 836)"
      width="80"
    />
    <rect
      fill="#F8FAFB"
      height="80"
      rx="8"
      transform="matrix(1 0 0 -1 302 164)"
      width="80"
    />
    <rect
      fill="#F8FAFB"
      height="80"
      rx="8"
      transform="matrix(1 0 0 -1 302 80)"
      width="80"
    />
    <rect
      fill="#F6F8FA"
      height="80"
      rx="8"
      transform="matrix(1 0 0 -1 218 836)"
      width="80"
    />
    <rect
      fill="#F8FAFB"
      height="80"
      rx="8"
      transform="matrix(1 0 0 -1 218 752)"
      width="80"
    />
    <rect
      fill="#F8FAFB"
      height="80"
      rx="8"
      transform="matrix(1 0 0 -1 218 164)"
      width="80"
    />
    <rect
      fill="#F8FAFB"
      height="80"
      rx="8"
      transform="matrix(1 0 0 -1 218 80)"
      width="80"
    />
    <rect
      fill="#F8FAFB"
      height="80"
      rx="8"
      transform="matrix(1 0 0 -1 134 836)"
      width="80"
    />
    <rect
      fill="#F6F8FA"
      height="80"
      rx="8"
      transform="matrix(1 0 0 -1 134 752)"
      width="80"
    />
    <rect
      fill="#F6F8FA"
      height="80"
      rx="8"
      transform="matrix(1 0 0 -1 134 668)"
      width="80"
    />
    <rect
      fill="#F6F8FA"
      height="80"
      rx="8"
      transform="matrix(1 0 0 -1 134 416)"
      width="80"
    />
    <rect
      fill="#F2F5F9"
      height="80"
      rx="8"
      transform="matrix(1 0 0 -1 134 332)"
      width="80"
    />
    <rect
      fill="#F8FAFB"
      height="80"
      rx="8"
      transform="matrix(1 0 0 -1 134 80)"
      width="80"
    />
    <rect
      fill="#F8FAFB"
      height="80"
      rx="8"
      transform="matrix(1 0 0 -1 50 836)"
      width="80"
    />
    <rect
      fill="#F6F8FA"
      height="80"
      rx="8"
      transform="matrix(1 0 0 -1 50 752)"
      width="80"
    />
    <rect
      fill="#F2F5F9"
      height="80"
      rx="8"
      transform="matrix(1 0 0 -1 50 668)"
      width="80"
    />
    <rect
      fill="#F2F5F9"
      height="80"
      rx="8"
      transform="matrix(1 0 0 -1 50 500)"
      width="80"
    />
    <rect
      fill="#F2F5F9"
      height="80"
      rx="8"
      transform="matrix(1 0 0 -1 50 416)"
      width="80"
    />
    <rect
      fill="#EBEDF5"
      height="80"
      rx="8"
      transform="matrix(1 0 0 -1 50 332)"
      width="80"
    />
    <rect
      fill="#F4F6F8"
      height="80"
      rx="8"
      transform="matrix(1 0 0 -1 -34 836)"
      width="80"
    />
    <rect
      fill="#F6F8FA"
      height="80"
      rx="8"
      transform="matrix(1 0 0 -1 -34 752)"
      width="80"
    />
    <rect
      fill="#F2F5F9"
      height="80"
      rx="8"
      transform="matrix(1 0 0 -1 -34 668)"
      width="80"
    />
    <rect
      fill="#EBEDF5"
      height="80"
      rx="8"
      transform="matrix(1 0 0 -1 -34 584)"
      width="80"
    />
    <rect
      fill="#F2F5F9"
      height="80"
      rx="8"
      transform="matrix(1 0 0 -1 -34 332)"
      width="80"
    />
    <rect
      fill="#F2F5F9"
      height="80"
      rx="8"
      transform="matrix(1 0 0 -1 -34 248)"
      width="80"
    />
  </svg>
</template>

<script>
export default {
  name: 'NlpLeftBackground',
}
</script>